import React, { useLayoutEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Routes, Route } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";

import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import withNavigate from "../../hocs/withNavigate";
import withToast from "../../hocs/withToast";
import { useSelector } from "react-redux";
import PatientEnrollment from "../../feature/Patients/PatientEnrollment";
import CareTeamManagement from "../../feature/CareTeam/CareTeamManagement";
import DeviceManagement from "../../feature/Devices/DeviceManagement";
import PatientPopulationTable from "../../feature/PatientPopulation/PatientPopulationTable";
import PatientPopulation from "../../feature/PatientPopulation/PatientPopulation";

import "./Layout.css";
import PatientChart from "../../feature/PatientPopulation/PatientChart/PatientChart";
import PatientList from "../../feature/PatientPopulation/PatientList";

const Layout = ({ navigate }) => {
  const { userType } = useSelector((state) => state.auth);
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState(() => (typeof window !== "undefined" ? window.innerWidth : 1024)); // Default to a reasonable size


  useLayoutEffect(() => {
    const updateSize = () => setSize(window.innerWidth);
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const renderProtectedRoutes = () => {
    if (userType === 'CareTeam') {
      return (
        <Routes>
          <Route path="patient-enrollment" element={<PatientEnrollment />} />
          <Route path="device-management" element={<DeviceManagement />} />
          <Route path="patient-population" element={<PatientPopulation />} />
          <Route path="patient-population-table" element={<PatientPopulationTable />} />
          <Route path="view-all-patient" element={<PatientList />} />
          <Route path="patient-chart" element={<PatientChart />} />
          <Route path="*" element={<PatientPopulation />} />
        </Routes>
      )
    }

    return (
      <Routes>
        <Route path="patient-enrollment" element={<PatientEnrollment />} />
        <Route path="care-team" element={<CareTeamManagement />} />
        <Route path="device-management" element={<DeviceManagement />} />
        <Route path="patient-population" element={<PatientPopulation />} />
        <Route path="patient-population-table" element={<PatientPopulationTable />} />
        <Route path="view-all-patient" element={<PatientList />} />
        <Route path="patient-chart" element={<PatientChart />} />
        <Route path="*" element={<PatientEnrollment />} />
      </Routes>
    )
  };

  const toggleDrawer = (newOpen) => {
    setOpen(newOpen);
  };

  return (
    <div className="layout-container">
      <Navbar />
      <div className="layout-content d-flex mt-1">
        {size > 500 && <Sidebar className="sidebar" />}

        <div className="main-content main-panel w-100 p-3">
          {size <= 500 && (
            <>
              <Button variant="text" onClick={() => toggleDrawer(true)}>
                <GiHamburgerMenu />
              </Button>
              <Drawer anchor="left" open={open} onClose={() => toggleDrawer(false)}>
                <Sidebar />
              </Drawer>
            </>
          )}
          <Container fluid className="content-container p-4">
            {renderProtectedRoutes()}
          </Container>
        </div>
      </div>
    </div>
  );
};

export default withToast(withNavigate(Layout));